import { Injectable } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { Adapter } from "../Interfaces/adapter";

export class Category {
    constructor(
        public categoriestable: string ,
        public categoryID: number,
        public description: string,
        public active: string,
        public imageFileName_MouseOut: string,
        public imageFileName_MouseOver: string
    ){ }
}

@Injectable({
    providedIn: 'root'
})

export class CategoryAdapter implements Adapter<Category> {
    adapt(item: any): Category {
        return new (
            item.categoriestable,
            item.categoryID,
            item.description,
            item.active,
            item.imageFileName_MouseOut,
            item.imageFileName_MouseOver
        );
    }
}
